module.exports = __webpack_public_path__ + "assets/27703072580072794dc8230c2672d925.svg";